export const config = {
  publicPath: 'local-path/',
  frontChatId: 'bd42f3b5952f8824fe3349e195c89231',
  co_brand: 'hdca',
  stripeKey:
    'pk_test_51KxaX9CCE8yTOgvc79FIksnAZ4rnvkNk7ylcoWZVYkEEgCw5Cyc013jB9pwMuJerQEJQUrUEgMAcXLNZokRSNU7q00X1CRl8p9',
  environment: 'development',
  region: 'NA',
  segmentUserIdPrefix: '',
}

export type ConfigurationType = {
  frontChatId: string
  sentryDSN: string
  publicPath: string
  segmentWriteKey: string
  muiKey: string
  stripeKey: string
  csrfToken: string
  environment: string
  region: string
  segmentUserIdPrefix: string
}

export const mapConfigurationTo = (config: any): ConfigurationType => {
  const context = {
    frontChatId: config.frontChatId,
    publicPath: config.publicPath,
    sentryDSN: config.sentryDSN,
    muiKey: config.muiKey,
    stripeKey: config.stripeKey,
    segmentWriteKey: config.segmentWriteKey,
    environment: config.environment,
    region: config.region || 'NA',
    segmentUserIdPrefix: config.segmentUserIdPrefix || '',
  } as ConfigurationType

  return context
}
